import { ReqBodyType } from './types/reqBody';
import HttpClient from './utils/HttpClient';

interface ICustomerRequestsService {
  token: string;
  reqBody?: ReqBodyType;
}

class CustomerRequestsService {
  private readonly httpClient: HttpClient;
  constructor() {
    this.httpClient = new HttpClient(process.env.REACT_APP_NEST_API ?? '', false);
  }

  sendEmails = async ({
    token,
    reqBody,
  }: ICustomerRequestsService) => {
    return this.httpClient.post({
      token,
      path: '/utils/send-emails',
      reqBody,
    });
  };
}

export default new CustomerRequestsService();
